//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debug from 'debug'
import waypointMixin from '@/mixins/waypoint'

const log = debug('HomeHowTo')

export default {
  name: 'HomeHowTo',
  mixins: [waypointMixin],
  mounted() {
    log('HomeHowTo')
  },
}
